import React, { useState } from 'react';
import { StickyTopBar } from './components/layout/StickyTopBar';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import { HomePage } from './pages/HomePage';
import { ContactPage } from './pages/ContactPage';
import { ServicePageTemplate } from './pages/ServicePageTemplate';
import { AboutPage } from './pages/AboutPage';
import { LocationPageTemplate } from './pages/LocationPageTemplate';
import { ServicesHub } from './pages/ServicesHub';
import { IndustriesHub } from './pages/IndustriesHub';
import { ResourcesHub } from './pages/ResourcesHub';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { PhoneIcon, ClipboardListIcon } from 'lucide-react';
export function App() {
  const [currentPage, setCurrentPage] = useState('home');
  // Simple router
  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <HomePage data-id="element-0" />;
      case 'contact':
        return <ContactPage data-id="element-1" />;
      case 'services-hub':
        return <ServicesHub setPage={setCurrentPage} data-id="element-2" />;
      case 'services':
        // Individual service template
        return <ServicePageTemplate setPage={setCurrentPage} data-id="element-3" />;
      case 'about':
        return <AboutPage setPage={setCurrentPage} data-id="element-4" />;
      case 'location':
        return <LocationPageTemplate setPage={setCurrentPage} data-id="element-5" />;
      case 'industries':
        return <IndustriesHub setPage={setCurrentPage} data-id="element-6" />;
      case 'resources':
        return <ResourcesHub setPage={setCurrentPage} data-id="element-7" />;
      case 'privacy':
        return <PrivacyPolicy data-id="element-8" />;
      default:
        return <HomePage data-id="element-9" />;
    }
  };
  return <div className="min-h-screen flex flex-col font-body text-charcoal bg-white" data-id="element-10">
      <StickyTopBar data-id="element-11" />
      <Header setPage={setCurrentPage} currentPage={currentPage} data-id="element-12" />

      <main className="flex-grow" data-id="element-13">{renderPage()}</main>

      <Footer setPage={setCurrentPage} data-id="element-14" />

      {/* Sticky Mobile Bottom CTA Bar */}
      <div className="md:hidden fixed bottom-0 left-0 w-full bg-white border-t border-steel-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 flex" data-id="element-15">
        <a href="tel:5177778088" className="flex-1 flex items-center justify-center py-4 bg-charcoal text-white font-heading font-bold uppercase tracking-wider text-sm" data-id="element-16">
          <PhoneIcon className="w-4 h-4 mr-2" data-id="element-17" />
          Call Now
        </a>
        <button onClick={() => {
        setCurrentPage('contact');
        window.scrollTo(0, 0);
      }} className="flex-1 flex items-center justify-center py-4 bg-brand-red text-white font-heading font-bold uppercase tracking-wider text-sm" data-id="element-18">
          <ClipboardListIcon className="w-4 h-4 mr-2" data-id="element-19" />
          Get Quote
        </button>
      </div>

      {/* Spacer for mobile bottom bar so content isn't hidden behind it */}
      <div className="h-[56px] md:hidden w-full bg-steel-950" data-id="element-20"></div>
    </div>;
}